import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 pt-20">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 mb-6">
        <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
      </div>
      <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground-900 mb-3">404</h1>
      <p className="text-base text-foreground-600 mb-8">抱歉，您访问的页面不存在</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors duration-200 whitespace-nowrap"
      >
        <i className="ri-home-line"></i>
        返回首页
      </Link>
    </div>
  );
}